<template>
  <b-button class="col col-lg-12 m-1" @click="scoringRequested">
    {{ round.name }}
    <b-badge variant="primary">{{ round.score }}</b-badge>
  </b-button>
</template>

<script>
export default {
  name: "QuizScoringButton",
  props: ["round"],
  methods: {
    scoringRequested() {
      this.$emit("scoring-requested", this.round.id);
    }
  }
};
</script>
